<template>
<div class="container pb-4 mb-4">
<div class="row justify-content-center">

<div class="col-md-8 mx-auto" v-if="enabled == 0">
<need-subscription></need-subscription>
</div>

<div v-else class="col">
  
<div class="row pb-4 pb-md-2">
<div class="col-6">

<!-- desktop -->
<h5 class="d-none d-md-table">
<span v-if="demo == 1">Live Demo</span>
<a v-else :href="`https://${site.name}`" target="_blank">{{site.name}}</a>
</h5>

<!-- mobile -->
<div class="d-md-none">
<span v-if="demo == 1">Live Demo</span>
<div v-else><a :href="`https://${site.name}`" target="_blank">{{site.name}}</a></div>
</div>

</div>
<div class="col-6 pt-md-2 text-right">

<a v-if="demo == 1" href="/"><i class="fa-solid fa-arrow-left pr-2"></i>Back home</a>

<span v-else>

<!-- desktop -->
<span class="d-none d-md-table w-100">
  <a href="/websites" class="mr-3"><i class="fa-solid fa-arrow-left pr-2"></i>Back to sites</a>
  <span class="dropdown">
  <a href="#" role="button" data-toggle="dropdown" aria-expanded="false">
    <i class="fas fa-bars pr-2"></i>Settings
  </a>

  <div class="dropdown-menu">
    <a class="dropdown-item" href="#/" title="Delete site" @click="showDeleteSite()"><i class="fas fa-trash mr-2"></i>Delete site</a>
  </div>
</span>
</span>

<!-- mobile -->
<span class="d-md-none">
  <a href="/websites" class="mr-4"><i class="fa-solid fa-arrow-left pr-2"></i></a>
  <a href="#/" @click="showDeleteSite()"><i class="fas fa-trash"></i></a>
</span>

</span>
</div>
</div>

<visitor-summary :site_id="site.id"></visitor-summary>

<live-feed :site="site"></live-feed>

<delete-site ref="DeleteSite" :site="site" page="view"></delete-site>

</div>

</div>

<div v-if="demo == 1" class="pt-4 pb-4 mt-4 mb-0 text-center">
<div class="pb-4 mb-2" style="font-size:2rem;font-weight:800;">Get a live feed of your website visitors</div>
<div class="col-md-10 mx-auto">
  <div class="row">
    <div class="col text-right pb-md-0 pb-4">
      <a href="/register" class="btn btn-success signup">Start free trial</a>
    </div>
    <div class="col text-left pb-md-0 pb-4">
      <a href="/" class="btn btn-danger signup">Learn more</a>
    </div>
  </div>
</div>
</div>
</div>
</template> 

<script>
export default {
  props: ['site','demo','enabled'],

  methods: {
    showTrackingCode() { 
      this.$bvModal.show('bv-modal-tracking-code'); 
      },
    showDeleteSite() { 
      this.$refs.DeleteSite.clearContent();
      this.$bvModal.show('bv-modal-delete-site'); 
      },
  },
}
</script>